import React, { createContext, useContext, useState, useEffect } from 'react';
import { onAuthStateChanged } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { auth, db } from "../firebaseConfig";

const UserPlanContext = createContext();

export const UserPlanProvider = ({ children }) => {
  const [plan, setPlan] = useState('GRATUITO');

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          const userDoc = await getDoc(doc(db, "USER", user.uid));
          if (userDoc.exists()) {
            setPlan(userDoc.data().SUBSCRIPTION_INFO.PLANO || 'GRATUITO');
          }
        } catch (error) {
          console.error("Erro ao buscar plano do usuário:", error);
        }
      } else {
        setPlan('GRATUITO');
      }
    });
    return () => unsubscribe();
  }, [auth, db]);

  return (
    <UserPlanContext.Provider value={{ plan }}>
      {children}
    </UserPlanContext.Provider>
  );
};

export const useUserPlan = () => useContext(UserPlanContext);